module.exports = __webpack_public_path__ + "img/merck-small.2a5a8b2f.png";